/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowOutdoorWellnessDayTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowOutdoorWellnessDay,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Focus on Wellness Outdoors!",
    "Outdoor Wellness Day Awaits!",
    "Health and Happiness in Nature!",
  ],
  title: "Outdoor Wellness Day",
  description: "Organize a fun outdoor wellness day.",
  longDescription:
    "Gather your friends for an exciting outdoor wellness day! Choose a date, decide on wellness activities, and plan refreshments!",
  emoji: "🌼",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Outdoor Wellness Day",
          emoji: "🌼",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the outdoor wellness day?",
          emoji: "📅",
          completeAction: {
            question: "Decide on wellness activities?",
            description: "What activities should we focus on during the day?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What activities should we consider?",
                emoji: "🧘",
                completeAction: {
                  question: "Decide on refreshments?",
                  description: "What refreshments should we plan for the day?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What refreshments should we bring?",
                      emoji: "🍵",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Focus on Wellness Together!",
    outroDescription: "Your outdoor wellness day plans are set! Enjoy the fun!",
  },
};
